import { useEffect, useState } from "react";
import Logo from "./logo";

export default function Header({ toggleModal }) {
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section
      className={`fixed left-0 top-0 w-full  py-3 z-50 transition-colors duration-300 ${isSticky
        ? "bg-[linear-gradient(45deg,#0F002E_0%,#350C69_100%)] shadow-lg"
        : "bg-transparent lg:py-[20px]  md:py-4 "}`}
      id="header"
    >
      <div className="relative block w-full">
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
          <div className="xl:flex hidden items-center justify-between lg:grid-cols-3 gap-4">
            <div className="xl:col-span-2 col-span-12">
              <Logo />
            </div>
            <div className="xl:col-span-4 col-span-12">
              <div className="flex gap-3">
                <button
                  className="relative flex xl:w-auto lg:auto w-full py-2 px-5 min-h-[45px] items-center justify-center gap-2 overflow-hidden bg-transparent border border-solid border-white hover:border-[#7C46EF] rounded-[10px] text-white shadow-2xl text-base font-medium transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-full before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-64 animate-cta-btn"
                  onClick={toggleModal}
                >
                  <span className="relative z-10">Request a Quote</span>
                  {/* <svg
                    className="w-4 h-4 text-white z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg> */}
                </button>
              </div>
            </div>
          </div>
          <div className="xl:hidden flex items-center justify-between lg:grid-cols-2 gap-4">
            <div className="xl:col-span-2 col-span-12">
              <Logo />
            </div>
            <div className="xl:col-span-10 col-span-12 flex items-center gap-3">
              <div>
                <button
                  className="relative flex xl:w-auto lg:auto w-full py-2 lg:px-5 px-3 min-h-[45px] items-center justify-center gap-2 overflow-hidden bg-transparent border border-solid border-white hover:border-[#7C46EF] rounded-[10px] text-white shadow-2xl text-base font-medium transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-full before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-64 animate-cta-btn"
                  onClick={toggleModal}
                >
                  <span className="relative z-10">Request a Quote</span>
                  {/* <svg
                    className="w-4 h-4 text-white z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg> */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
